import styled from '@emotion/styled';

import { HardSkillIcon } from '../../core/icons/HardSkillIcon';
import { SoftSkillIcon } from '../../core/icons/SoftSkillIcon';

import type { HTMLAttributes, ReactNode } from 'react';
import type { FunctionComponent } from 'react';

export type SkillBadgeProps = HTMLAttributes<HTMLDivElement> & {
    readonly actions?: ReactNode;
    readonly skill: {
        readonly title: string;
        readonly type: 'hard' | 'language' | 'soft';
    };
};

const StyledSkillBadge = styled.div<SkillBadgeProps>`
    ${({ theme }) => {
        return {
            '& > svg': {
                flexShrink: 0,
            },
            '&:hover': {
                backgroundColor: theme.colors.gray[300],
                cursor: 'pointer',
            },
            '&>span': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
            alignItems: 'center',
            backgroundColor: theme.colors.gray[200],
            borderRadius: theme.borderRadius.m,
            boxShadow: theme.shadows.medium,
            color: theme.colors.black[900],
            cursor: 'default',
            display: 'flex',
            fontFamily: theme.typography.body.S.medium.fontFamily,
            fontSize: '0.875rem',
            fontWeight: theme.typography.body.S.medium.fontWeight,
            gap: theme.spacing.s,
            justifyContent: 'center',
            letterSpacing: '-0.0175rem',
            lineHeight: '1.25rem',
            overflow: 'hidden',
            padding: `${theme.spacing.s} ${theme.spacing.l}`,
            userSelect: 'none',
            WebkitFontSmoothing: 'antialiased',
        };
    }}
`;

export const SkillBadge: FunctionComponent<SkillBadgeProps> = ({ actions, skill, ...props }) => {
    return (
        <StyledSkillBadge skill={skill} {...props}>
            {skill.type === 'hard' ? <HardSkillIcon /> : <SoftSkillIcon />}
            <span>{skill.title}</span>
            {actions}
        </StyledSkillBadge>
    );
};
